import { observer } from 'mobx-react-lite';
import { Form, Select } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { countConfigDetails } from '../fixture';

function Task() {
  // -------------------- Stores ------------------------ //
  const { DashboardConfigurationStore } = useStore();

  return (
    <div style={{ marginTop: '16px' }}>
      <h4>Count Properties</h4>
      <Form.Field
        control={Select}
        placeholder={'Select Count Type'}
        clearable
        fluid
        search
        selection
        options={countConfigDetails}
        onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
          if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
            e.stopPropagation();
        }}
        style={{ marginTop: '5px' }}
        value={DashboardConfigurationStore.task.count}
        onChange={(_e: any, data: any) =>
          (DashboardConfigurationStore.task.count = data.value)
        }
      />
    </div>
  );
}

export default observer(Task);
